import React from 'react';

export default function StatsBar() {
  const stats = [
    { num: 'Same', label: 'Day Service' },
    { num: '100%', label: 'Local & Trusted' },
    { num: '⭐5.0', label: 'Star Rated' },
    { num: '9+', label: 'Areas Served' },
  ];

  return (
    <div className="bg-gold flex justify-around flex-wrap py-8 px-[8%] lg:px-[12%] gap-5">
      {stats.map((stat, i) => (
        <div key={i} className="text-center">
          <div className="font-condensed font-black text-[42px] leading-none text-dark">{stat.num}</div>
          <div className="text-[13px] font-bold text-dark/65 tracking-wide uppercase mt-1">{stat.label}</div>
        </div>
      ))}
    </div>
  );
}